import React from "react";
import ServiceHeader from "../components/services/ServiceHeader";
import ServiceSections from "../components/services/ServiceSections";

const ServicesMain = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <ServiceHeader />
      <ServiceSections />
    </div>
  );
};

export default ServicesMain;
